import type { GpsStreamCheck } from './gpsStreamTrust'
import { isUsableGpsFix, type GpsFixReading } from '../gpsFix'

function whyNoFixIsUsable(fixes: readonly GpsFixReading[]): string {
  if (fixes.length === 0) return 'There is no GPS fix'
  if (fixes.every((fix) => Math.abs(fix.longitude) > 180))
    return 'Every GPS longitude is outside ±180°'
  if (fixes.every((fix) => fix.latitude === 0 && fix.longitude === 0))
    return 'Every GPS position is at (0, 0)'
  return 'No GPS fix is usable'
}

export const positionsOnTheGlobe: GpsStreamCheck = {
  id: 'positionsOnTheGlobe',
  run(fixes, trust) {
    if (fixes.some(isUsableGpsFix)) return { trust, finding: null }
    return {
      trust: { ...trust, positionsUsable: false },
      finding: {
        check: 'positionsOnTheGlobe',
        level: 'stream',
        aspect: 'gpsPosition',
        verdict: 'unusable',
        affected: fixes.length,
        of: fixes.length,
        reason: whyNoFixIsUsable(fixes),
      },
    }
  },
}
